import { useQuery } from '@tanstack/react-query';

import { SearchOimContactParams, useOimApiProxyService } from './oim-api-proxy.service';

const oimContactApiKey = 'oim-contact';

export const useSearchOimContact = (params: SearchOimContactParams) => {
  const service = useOimApiProxyService();

  return useQuery({
    queryKey: [oimContactApiKey, params],
    queryFn: () => service.searchOimContact(params),
    enabled: false,
  });
}
